import React from 'react'

import { Trans } from '@lingui/macro'
import { observer } from 'mobx-react-lite'
import { appStore } from '../../AppStore'
import { clientStore } from '../../../client/ClientStore'
import { employeeStore } from '../../../end-user/EmployeeStore'
import { SCOPES } from '../../../config/constants'
import {
  Button,
  ButtonLayout,
  ButtonPrimary,
  DialogContent,
  DialogHeader,
  Icon,
  List,
  ListItem,
  ReachDialog,
} from '../../ui-kit'

export const ModalMigratedUser: React.FC = observer(() => {
  const { currentUserAccesses, currentRole } = appStore

  let currentAccessId: string | undefined
  if (currentRole === SCOPES.Holder && employeeStore.employee) {
    currentAccessId = appStore.getUserAccessFromId(employeeStore.employee.id)?.scope_object_id
  } else if (currentRole === SCOPES.Client) {
    currentAccessId = clientStore.client?.id
  }

  const allowClose = appStore.isMigratedAdmin

  const otherAccesses = currentUserAccesses.filter(
    access => access.scope_object_id !== currentAccessId
  )

  return !appStore.showMigrationModal ? null : (
    <ReachDialog size="large">
      <DialogHeader
        close={allowClose ? () => appStore.dismissMigrationModal() : undefined}
        closeButton={allowClose ? undefined : <span />}
        title={
          (
            <h2 className="h5">
              <Trans>Účet bol zmigrovaný</Trans>
            </h2>
          ) as any
        }
      />

      <DialogContent>
        <p
          style={{
            textAlign: 'center',
            marginTop: '1rem',
            marginBottom: '1rem',
            maxWidth: '440px',
            alignSelf: 'center',
            justifySelf: 'center',
          }}>
          <Trans>
            Váš účet bol úspešne zmigrovaný na novú zónu. Pokračujte, prosím, k prihláseniu pomocou
            odkazu nižšie.
          </Trans>
        </p>

        <ButtonLayout direction="horizontal" className="align-items-center">
          <ButtonPrimary href="https://benefity.mojeup.sk/login/r">
            <Trans>Prihlásiť sa do novej zóny</Trans>
          </ButtonPrimary>
        </ButtonLayout>

        {otherAccesses.length > 0 && (
          <>
            <hr
              style={{
                width: '100%',
                margin: '1.5rem 0 0',
                borderTop: '1px solid #e0e0e0',
                borderBottom: 'none',
              }}
            />

            <p
              style={{
                textAlign: 'center',
                marginTop: '1rem',
                marginBottom: '1rem',
                maxWidth: '440px',
                alignSelf: 'center',
                justifySelf: 'center',
              }}>
              <Trans>
                V prípade,že potrebujete prístup k pôvodnému Archívu dokumentov, vyberte si účet z
                nasledujúceho zoznamu:
              </Trans>
            </p>

            <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
              <List clean className="mb-none" style={{ marginTop: '1rem' }}>
                {otherAccesses.map(access => (
                  <ListItem key={access.scope_object_id} className="no-pad">
                    <ButtonLayout className="mb-none">
                      <Button
                        type="link-secondary"
                        className="text-left"
                        onClick={() => {
                          if (access.scope === SCOPES.Holder) {
                            employeeStore.saveEmployeeIdToLocalStorage(access.scope_object_id)
                            location.assign('/end-user')
                          } else if (access.scope === SCOPES.Client) {
                            clientStore.saveClientIdToLocalStorage(access.scope_object_id)
                            location.assign('/client')
                          }
                        }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <Icon
                            name={access.scope === SCOPES.Holder ? 'user' : 'company'}
                            size="medium"
                            className="icon--left"
                          />
                          <span>{access.name}</span>
                        </div>
                      </Button>
                    </ButtonLayout>
                  </ListItem>
                ))}
              </List>
            </div>
          </>
        )}
      </DialogContent>
    </ReachDialog>
  )
})

ModalMigratedUser.displayName = 'ModalMigratedUser'
